let x = new Date();
let currentTimeZoneOffset = x.getTimezoneOffset() * 60 * 1000;

export function getInnerText (htmlContent) {
  let d = document.createElement('div');
  d.innerHTML = htmlContent;
  return d.textContent || d.innerText;
}

export function timeToString (int1, int2) {
  // int1: created_at, int2: updated_at
  let updated;
  if (int1 === undefined) int1 = new Date().getTime();
  if (int2 === undefined) int2 = int1;
  if (int2 - int1 < 1000) {
    updated = '';
  } else {
    updated = ' (수정됨)';
  }
  const dateString = new Date(int1 - currentTimeZoneOffset).toISOString();
  let year = dateString.slice(2, 4);
  let month = dateString.slice(5, 7);
  let day = dateString.slice(8, 10);
  let time = dateString.slice(11, 16);
  return `${year}년 ${month}월 ${day}일 ${time}${updated}`;
}

export function timeToDotString (int1, int2, now) {
  // int1: created_at, int2: updated_at
  let updated;
  if (int1 === undefined) int1 = new Date().getTime();
  if (int2 === undefined) int2 = int1;
  if (int2 - int1 < 1000) {
    updated = '';
  } else {
    updated = '(수정됨) ';
  }
  if (now - int1 <= 60000) {
    // 60 sec = 60000 ms 이내
    return `방금`;
  } else if (now - int1 <= 3600000) {
    // 60 min = 3600000 ms 이내
    return `${parseInt((now - int1) / 60000)}분 전`;
  } else if (now - int1 <= 86400000) {
    // 24 h = 86400000 ms 이내
    return `${parseInt((now - int1) / 3600000)}시간 전`;
  } else if (now - int1 <= 604800000) {
    // 7 d = 604800000 ms 이내
    return `${parseInt((now - int1) / 86400000)}일 전`;
  } else {
    // eq or more than 7 d
    const dateString = new Date(int1 - currentTimeZoneOffset).toISOString();
    let year = dateString.slice(2, 4);
    let month = dateString.slice(5, 7);
    let day = dateString.slice(8, 10);
    let time = dateString.slice(11, 16);
    return `${updated}${year}.${month}.${day} ${time}`;
  }
}

export function intToCommaString (int) {
  return int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function intToString (int) {
  if (int < 10000) {
    return int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  } else {
    return (Math.floor(int / 100) / 10).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + 'k';
  }
}

export function copyLink (path) {
  let isiOS = navigator.userAgent.match(/ipad|iphone/i) !== null;
  let range, selection;
  // append fake element
  let textarea = document.createElement('textarea');
  textarea.value = path;
  textarea.setAttribute('readonly', 'readonly');
  textarea.setAttribute('style', 'position: absolute; top: -1px; left: -50px; width: 1px;');
  document.getElementsByTagName('body')[0].appendChild(textarea);
  // set selection & get selection
  if (isiOS) {
    range = document.createRange();
    range.selectNodeContents(textarea);
    selection = document.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    textarea.setSelectionRange(0, 999999);
  } else {
    textarea.select();
  }
  document.execCommand('copy');
  textarea.remove();
}

export function urlToLink (text) {
  if (!text) return '';
  // let exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  let exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  let text1 = text.replace(exp, `<a target="_blank" href="$1" style="font: inherit">$1</a>`);
  // let exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  let exp2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
  return text1.replace(exp2, `$1<a target="_blank" href="http://$2" style="font: inherit">$2</a>`);
}
